import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import debounce from 'lodash/debounce';
import { Document } from './document';
export class Preview extends React.PureComponent {
    documentRef;
    constructor(props) {
        super(props);
        this.state = {
            scale: 0,
        };
        this.documentRef = React.createRef();
    }
    fit = () => {
        if (this.props.parentRef.current && this.documentRef.current) {
            const parentRect = this.props.parentRef.current.getBoundingClientRect();
            // 60 ~ buffer for spacing around document
            // verticalRatio = parentRect.height / this.pageRef.current.offsetHeight;
            const horizontalRatio = (parentRect.width - 60) / this.documentRef.current.offsetWidth;
            this.setState({
                // scale: horizontalRatio < verticalRatio ? horizontalRatio : verticalRatio
                scale: horizontalRatio > 1 ? 1 : horizontalRatio,
            });
        }
    };
    debounceFit = debounce(this.fit, 500);
    componentDidUpdate() {
        this.fit();
    }
    componentDidMount() {
        this.fit();
        window.addEventListener('resize', this.debounceFit);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.debounceFit);
    }
    render() {
        if (this.props.size) {
            return (_jsx("div", { className: 'rpx-preview', style: {
                    // @ts-ignore
                    '--RPX_PREVIEW_SCALE': this.state.scale,
                }, children: _jsx("div", { className: 'rpx-preview--inner', children: _jsx(Document, { reference: this.documentRef, scale: this.state.scale, size: this.props.size, orientation: this.props.orientation, margins: this.props.margins, pageTemplates: this.props.pageTemplates }) }) }));
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=component.js.map